import { metrics } from '@atlassian/browser-metrics';

export const filtersDirectoryPageLoad = metrics.pageLoad({
	key: 'filters-directory',
	ssr: {
		doneAsFmp: true,
	},
});
